import React from 'react';
import { I18nextProvider } from 'react-i18next';

import AntdProvider from './config-antd-provider';
import i18n from './services/i18n';

const ConfigProvider = ({ children }: { children: React.ReactNode }) => {
	return (
		<I18nextProvider i18n={i18n} defaultNS={'common'}>
			<AntdProvider>{children}</AntdProvider>
		</I18nextProvider>
	);
};

export default ConfigProvider;
